<template>
  <div class="plat-student-basic-info">
    <StudentInfoPanel ref="panel"
                      editable
                      v-bind="$attrs"
                      v-on="$listeners"
                      @start-refresh="startRefresh"
                      @end-refresh="endRefresh"></StudentInfoPanel>
  </div>
</template>

<script>
import StudentInfoPanel from '../../../../../../wrapper/panel/student/info'
import Dashboard from '../../../../../../../../../../mixins/custom/dashboard'
export default {
  name: 'PlatStudentBasicInfo',
  mixins: [Dashboard],
  components: {
    StudentInfoPanel
  },
  methods: {
    handleRefresh () {
      if (this.isCurrent) {
        const panel = this.$refs.panel
        if (panel) {
          panel.loadBasicInfo()
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .plat-student-basic-info {
    height: 100%;
  }
</style>
